export const dynamicFormCheckboxStyles = {
	formControlLabelStyles: {
		mt: '0.5rem',
		alignItems: 'flex-start',
	},
	checkboxStyles: { py: 0 },
};
